<template>
  <div>
    <confirm-mess :list="confirmList" :state= "state" v-transition></confirm-mess>
  </div>
</template>

<script>
import ConfirmMess from './components/Mess'
export default {
  name: 'Confirm',
  components: {
    ConfirmMess
  },
  data () {
    return {
      confirmList: [],
      state: true
    }
  },
  methods: {
    getConfirmInfo () {
      this.axios.get('/ApiOrderConfirm/GetSynthetic', {
        params: {
          Type: decodeURIComponent(this.$route.query.Type),
          goodid: decodeURIComponent(this.$route.query.goodid),
          BuyCount: decodeURIComponent(this.$route.query.buycount),
          cartids: decodeURIComponent([this.$route.query.cartids])
        }
      }).then(this.getConfirmInfoSucc)
        .catch(this.getConfirmInfoFail)
    },
    getConfirmInfoSucc (res) {
      res = res.data
      if (res.ret) {
        if (res.errorInfo === '') {
          const data = res.data
          this.confirmList = JSON.parse(data.confirmList)
        } else {
          alert(res.errorInfo)
          this.state = false
        }
      }
    },
    getConfirmInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getConfirmInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/confirm/Confirm.vue